import { render, staticRenderFns } from "./AnnouncementDetailModal.vue?vue&type=template&id=31cb16fa&scoped=true&"
import script from "./AnnouncementDetailModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementDetailModal.vue?vue&type=style&index=0&id=31cb16fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb16fa",
  null
  
)

export default component.exports